// assets/load-more.js

const loadItems = (button) => {
  const totalPages = parseInt($("[data-total-pages]").val(), 10);
  let currentPage = parseInt($("[data-current-page]").val(), 10);

  // On prépare le nouvel affichage
  currentPage += 1;
  $("[data-current-page]").val(currentPage);

  // Verrouille le bouton
  button.setAttribute("disabled", "");
  button.classList.add("loading");

  // On utilise l'URL courante manipulée + phcursor actuel
  const nextInput = $("[data-next-url]");
  const urlToFetch = nextInput.val().replace(/page=\d+/, "page=" + currentPage);

  $.ajax({
    url: urlToFetch,
    type: "GET",
    dataType: "html",
    success: function (responseHTML) {
      // 1) On injecte les nouveaux produits
      const $resp = $(responseHTML);
      $(".load-more-grid").append(
        $resp.find(".load-more-grid").html()
      );

      // 2) On récupère la VRAIE prochaine URL depuis le HTML renvoyé
      const realNext = $resp.find("input[data-next-url]").val();
      if (realNext) {
        nextInput.val(realNext); // on met à jour le curseur (phcursor)
      }

      // 3) On relance ta fonction de rafraîchissement des swatches
      if (typeof colorSwatches === "function") {
        colorSwatches();
      }
    },
    complete: function () {
      // Si on n'est pas à la dernière page, on réactive le bouton
      if (currentPage < totalPages) {
        button.removeAttribute("disabled");
        button.classList.remove("loading");
      } else {
        // sinon on supprime le bouton définitivement
        button.remove();
      }
    },
  });
};

const checkVisibility = () => {
  document.querySelectorAll(".js-infinite-scroll").forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
        }
      });
    });
    sectionObserver.observe(spinner);
  });
};

function loadMore() {
  document.querySelectorAll(".js-load-more").forEach((button) => {
    button.onclick = () => loadItems(button);
  });
  checkVisibility();
}

(function () {
  loadMore();
})();
